import { render, staticRenderFns } from "./Alumnis.vue?vue&type=template&id=f1fc965e&scoped=true"
import script from "./Alumnis.vue?vue&type=script&lang=js"
export * from "./Alumnis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fc965e",
  null
  
)

export default component.exports